import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { NotificationBell } from "@/components/NotificationBell";
import { DemoPreviewBanner } from "@/components/DemoPreviewBanner";
import { LogoSpin } from "@/components/LogoSpin";
import { ThemeToggle } from "@/components/ThemeToggle";
import privyLogomark from "@/assets/privy-logomark.png";

export function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <main className="flex-1 flex flex-col min-w-0">
          <DemoPreviewBanner />
          {/* Mobile top bar */}
          <header className="h-14 flex items-center justify-between border-b border-border px-4 shrink-0 md:hidden bg-background sticky top-0 z-30">
            <div className="flex items-center gap-3">
              <SidebarTrigger className="h-9 w-9" />
              <LogoSpin src={privyLogomark} alt="Privy" className="h-6 w-6" />
              <span className="font-semibold text-foreground">Privy</span>
            </div>
            <div className="flex items-center gap-1">
              <ThemeToggle />
              <NotificationBell />
            </div>
          </header>
          <div className="flex-1 overflow-x-hidden">{children}</div>
        </main>
      </div>
    </SidebarProvider>
  );
}
